import { FC } from "react";
// import cx from 'classnames';

const EsInvestment: FC = () => {
  return (
    <div className="pt-25 pb-15 md:pt-50">
      <p className="text-dark text-4xl leading-tight font-light">
        Senėjimo proceso
        <br />
        prevencijos protokolo
        <br />
        sukūrimas
      </p>
      <p>
        <br />
        Tiklas ir projekto rezultatai: Projekto tikslas - sukurti inovatyvią
        personalizuotą medicinos paslaugą, skirtą lėtinti senėjimo procesą ir
        gerinti sveikatą. Projekto metu bus atliktas biomedicininis tyrimas,
        kurio metu bus siekiama sujungti genetinius, epigenetinius ir kraujo
        laboratorinius tyrimus, siekiant įvertinti žmonių biologinį amžių, ir
        sukurti maisto papildų rinkinius, kurie lėtina senėjimo procesą bei
        tirti šių maisto papildų poveikį žmonių senėjimo procesui. Tikėtinas
        projekto rezultatas - sukurtas senėjimo proceso prevencijos protokolas,
        kuris leis pagerinti žmonių sveikatą ir lėtinti senėjimo procesą.
        <br />
        <br />
        Projektas įgyvendinamas pagal ekonominės transformacijos ir
        konkurencingumo plėtros programos pažangos priemonę Nr. 05-001-01-05-07.
        <br />
        <br />
        Projektas finansuojamas Europos regioninės plėtros fondo lėšomis.
        <br />
        <br />
        Projekto biudžetas 294806,4 €, ES fondo skirtas finansavimas 170.478,24
        €.
        <br />
        <br />
        Projekto įgyvendinimo laikotarpis 09/2023 – 30/09/2025.
        <br />
        <br />
        UAB Telomera.lt yra įmonė, kuri kuria ir teikia inovatyvias sveikatos
        priežiūros paslaugas, specializuojasi sveikatos skatinimo ir
        ilgaamžiškumo srityje. Projekto metu įmonės tyrėjai sukurs paslaugą,
        skirtą ilgaamžiškumo segmentui, kuri apims inovatyvius genetinius ir
        epigenetinius tyrimus, išsamų sveikatos rodiklių vertinimą,
        konsultacijas gyvensenos ir mitybos klausimais bei racionalų maisto
        papildų, svarbių ilgaamžiškumui, naudojimą. Sukurta paslauga bus
        pagrįsta mokslu - projekto metu planuojama atlikti biomedicininį tyrimą,
        kurio metu bus tiriamas maisto papildų poveikis žmonių savijautai,
        epigenetiniams ir kitiems rodikliams. Ateityje įmonė planuoja plėsti
        savo sveikatinimo paslaugų spektrą, populiarinti sveiką gyvenimo būdą ir
        kurti mokslu pagrįstas sveikatos priežiūros paslaugas.
        <br />
        <br />
        Kontaktai: Direktorius Dovydas Čalnaris, el. paštas: info@telomera.lt,
        telefonas: +370 639 88229.
        <br />
        <br />
        Daugiau informacijos: www.esinvesticijos.lt
      </p>
    </div>
  );
};

export default EsInvestment;
